import { injectIntl, IntlShape } from 'react-intl';
import { useState } from 'react';
import { Container } from '@material-ui/core';
import { get, isArray, isEmpty } from 'lodash';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import CivilJudgement from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgement';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { Listings } from 'containers/AppContainer/typings';
import {
  filterExpertises,
  formatExpertisesWithExpertReport,
  getMergedCivilJudgements,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { VictimType } from 'typings/globalTypes';

export interface CivilJudgementFormProps {
  judgementOnMerits: JudgementOnMeritsType;
  judgementAddDocuments: JudgementADDDocumentType[];
  intl: IntlShape;
  judgementOnMeritsRequest: any;
  setJudgementOnMeritsRequest: Function;
  judgementAddAppeal?: Function;
  dahirAmount: any;
  isDisabled: any;
  setIsDisabled: Function;
  allJudgementDocuments: any;
  isAppeal?: boolean;
  sharedResponsability: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  victims: VictimType[];
  injuredVictims: VictimType[];
  listings: Listings;
  isMultiple?: boolean | undefined;
  judgement: any;
  setJudgement: Function;
  expertiseReport: any;
}

export const CivilJudgementForm: React.FC<CivilJudgementFormProps> = ({
  isDisabled,
  isAppeal,
  ...props
}): JSX.Element => {
  const [
    currentJudgementCivilForms,
    setCurrentShowJudgementCivilForms,
  ] = useState<number[]>([]);

  const handleAddJudgementCivil = (id: number) => () => {
    setCurrentShowJudgementCivilForms([...currentJudgementCivilForms, id]);
    props.setIsDisabled({ ...isDisabled, [id]: false });
  };
  const showJudgementCivilForm = (id: number) =>
    currentJudgementCivilForms.find(el => el === id);

  const handleCivilJudgementChange = (civilJudgement: any) => {
    const mergedCivilJudgements = getMergedCivilJudgements(
      civilJudgement,
      props.judgementOnMeritsRequest,
    );

    const civjs = props.judgementOnMeritsRequest['civjs'].filter(
      (item: any) =>
        isArray(civilJudgement) &&
        !mergedCivilJudgements.some(
          (el: any) =>
            el.judgementAddDocumentId === item.judgementAddDocumentId,
        ),
    );

    return props.setJudgementOnMeritsRequest({
      ...props.judgementOnMeritsRequest,
      civjs:
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        isArray(civilJudgement)
          ? [...civjs, ...mergedCivilJudgements]
          : [...props.judgementOnMeritsRequest['civjs'], civilJudgement],
    });
  };

  const handleCancelCivilJudgement = (
    judgementAddId: number,
    recentAccountings: any,
  ) => {
    const judgementOnMeritsRequest = { ...props.judgementOnMeritsRequest };
    const judgementToRemove =
      judgementOnMeritsRequest.civjs.find(
        (item: any) => item.judgementAddDocumentId === judgementAddId,
      ) || {};
    const IdsToCheck = [] as any;
    const { civjmede = [], civjmece = [] } = judgementToRemove;
    civjmece.forEach((civj: any) => IdsToCheck.push(get(civj, 'vehiculeId')));
    civjmede.forEach((civj: any) => IdsToCheck.push(get(civj, 'victimId')));

    const result = judgementOnMeritsRequest.civjs
      .map((item: any) => {
        const filteredCivjacce = get(item, 'civjacce', []).filter(
          (civjacce: any) => {
            const hasMatch = recentAccountings.some((accounting: any) => {
              return (
                IdsToCheck.includes(
                  get(civjacce, 'vehiculeId', civjacce?.victimId),
                ) &&
                accounting.id ===
                  get(civjacce, 'vehiculeId', civjacce.victimId) &&
                accounting.expertiseJudgementAddDocumentId ===
                  civjacce.expertiseJudgementAddDocumentId
              );
            });
            return !hasMatch;
          },
        );

        return {
          ...item,
          civjacce: filteredCivjacce,
        };
      })
      .filter((item: any) => item.judgementAddDocumentId !== judgementAddId);

    return props.setJudgementOnMeritsRequest({
      ...props.judgementOnMeritsRequest,
      civjs: result,
    });
  };
  return (
    <main>
      {!isEmpty(props.allJudgementDocuments) && (
        <div>
          <div className="judgement-on-merits-title">
            {featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
              ? translate(messages.judgementCivilOrNonCompensation, props)
              : translate(messages.judgementCivil, props)}
          </div>
          <Container>
            {filterExpertises(
              formatExpertisesWithExpertReport(
                props.allJudgementDocuments,
                get(props.expertiseReport, 'victimExpertises', []),
                get(props.expertiseReport, 'vehiculeExpertises', []),
              ),
            ).map((judgementAddDocument: any, index: number) => (
              <div key={judgementAddDocument.id} className="judgement-add-doc">
                <div className="judgement-add-doc-title">
                  {translate(messages.judgementAdd, props, {
                    index: index + 1,
                    date: props.intl.formatDate(
                      judgementAddDocument.judgementDate,
                      {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      },
                    ),
                  })}
                </div>

                {!showJudgementCivilForm(Number(judgementAddDocument.id)) &&
                  !featureService.hasFeature(
                    FEATURES.REASONS_FOR_NON_COMPENSATION,
                  ) && (
                    <PrimaryButton
                      data-testid="add_new_civil_judgement"
                      onClick={handleAddJudgementCivil(
                        Number(judgementAddDocument.id),
                      )}
                      lefticon={<AddCircleOutlineIcon className="icon" />}
                      title={translate(messages.addButton, props)}
                      className="add-judgement-civil"
                    />
                  )}

                {((!featureService.hasFeature(
                  FEATURES.REASONS_FOR_NON_COMPENSATION,
                ) &&
                  showJudgementCivilForm(Number(judgementAddDocument.id))) ||
                  featureService.hasFeature(
                    FEATURES.REASONS_FOR_NON_COMPENSATION,
                  )) && (
                  <CivilJudgement
                    judgementAddId={judgementAddDocument.id}
                    judgementAddDocExpertises={judgementAddDocument.expertises}
                    handleCivilJudgementChange={handleCivilJudgementChange}
                    dahirAmounts={
                      props.dahirAmount as { [key: string]: number }
                    }
                    isDisabled={isDisabled}
                    setIsDisabled={props.setIsDisabled}
                    handleCancelCivilJudgement={handleCancelCivilJudgement}
                    judgementAddAppeal={props.judgementAddAppeal}
                    isAppeal={isAppeal}
                    sharedResponsability={props.sharedResponsability}
                    sagisVictimInfo={props.sagisVictimInfo}
                    sagisOpposingParties={props.sagisOpposingParties}
                    judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                    setJudgementOnMeritsRequest={
                      props.setJudgementOnMeritsRequest
                    }
                    listings={props.listings}
                    setJudgement={props.setJudgement}
                    judgement={props.judgement}
                    allJudgementDocuments={formatExpertisesWithExpertReport(
                      props.allJudgementDocuments,
                      get(props.expertiseReport, 'victimExpertises', []),
                      get(props.expertiseReport, 'vehiculeExpertises', []),
                    )}
                  />
                )}
              </div>
            ))}
          </Container>
        </div>
      )}
    </main>
  );
};
export default injectIntl(CivilJudgementForm);
